import { get } from "../../service/api";

const GetSettleTransactionSummary = async (merchantId, merchantSettleId) => {
    try {
        const response = await get(`/merchant/${merchantId}/merchantSettle/${merchantSettleId}/transactionSummary`);
        return response;
    } catch (error) {
        console.error('Error GetSettleTransactionSummary:', error);
        throw error;
    }
};

export default GetSettleTransactionSummary;
